"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var stockApiPing = {
    GET_STOCKAPIPING: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetStockPingApi {\n      stockApiPing\n    }\n  "], ["\n    query GetStockPingApi {\n      stockApiPing\n    }\n  "]))),
};
exports.default = stockApiPing;
var templateObject_1;
